import { AideAudienceStubPage } from '../../../../components/aides/AideAudienceStubPage';
import { AIDES_ENTREPRISES } from '../../../../config/aides-entreprises';

export default function OptimisationTurpePage() {
  const aide = AIDES_ENTREPRISES.find((a) => a.slug === 'optimisation-turpe');
  if (!aide) return null;
  return <AideAudienceStubPage aide={aide} audienceId="entreprises" />;
}
